// extracted by mini-css-extract-plugin
module.exports = {"card-container":"_5DIASKeD","info-section":"_5D11Hatm","header":"_5D3vI_zh","sub-title":"_5DQ2Gtb7","definition-list":"_5D2eZuFj","link":"_5D10zJ-V"};